import { debounceTime, Subject } from 'rxjs';
import { ContentWindowMessenger } from './ContentWindowMessanger';
import { WindowEventReceiver } from './WindowEvent';
import { MessageEventService } from './MessageEvent';
import { WindowsMessage } from './MessageEvent/WindowMessage';
import { WindowEvent } from './WindowEvent/WindowEvent';
export default class WindowPostMessageCommunicator {
    constructor(allowedOrigins, ContentWindows = [], currentWindow = window, windowEventReceiver = new WindowEventReceiver(new MessageEventService(allowedOrigins)), contentWindowMessenger = new ContentWindowMessenger(ContentWindows)) {
        this.allowedOrigins = allowedOrigins;
        this.ContentWindows = ContentWindows;
        this.currentWindow = currentWindow;
        this.windowEventReceiver = windowEventReceiver;
        this.contentWindowMessenger = contentWindowMessenger;
        this.topics = new Map();
        this.windowEventReceiver.messages.subscribe((message) => {
            this.sendToApplicationLevel(message.topic, message.data, message.origin);
        });
    }
    addSubject(topic) {
        const subject = new Subject();
        this.topics.set(topic, subject);
        return subject;
    }
    getSubject(topic) {
        const map = this.topics.get(topic);
        if (!map) {
            return this.addSubject(topic);
        }
        return map;
    }
    sendToApplicationLevel(topic, data, origin) {
        const model = new WindowEvent(data, topic, origin);
        const subject = this.getSubject(topic);
        subject.next(model);
    }
    sendToContentWindows(topic, data) {
        const model = new WindowEvent(data, topic, this.currentWindow.location.origin);
        try {
            this.contentWindowMessenger.postMessage(new WindowsMessage(model));
        }
        catch (e) {
            console.debug('no content window');
        }
    }
    sendToParent(topic, data) {
        const model = new WindowEvent(data, topic, this.currentWindow.location.origin);
        try {
            if (this.ContentWindows.length <= 0) {
                const channel = window === null || window === void 0 ? void 0 : window.parent;
                channel.postMessage(new WindowsMessage(model), this.currentWindow.document.referrer);
            }
        }
        catch (e) {
            console.debug('no parent');
        }
    }
    send(topic, data) {
        this.sendToParent(topic, data);
        this.sendToApplicationLevel(topic, data);
        this.sendToContentWindows(topic, data);
    }
    on(topic, cb, options) {
        const subject = this.getSubject(topic);
        if (options === null || options === void 0 ? void 0 : options.takeLatest) {
            const takeLatestSubscription = subject
                .pipe(debounceTime((options === null || options === void 0 ? void 0 : options.takeLatestTime) || 100))
                .subscribe(cb);
            this.topics.set(topic, subject);
            return takeLatestSubscription;
        }
        const subscription = subject.subscribe(cb);
        this.topics.set(topic, subject);
        return subscription;
    }
}
//# sourceMappingURL=WindowPostMessageCommunicator.js.map